"use strict";

function e(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function r(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function t() {
  return (t = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }).apply(this, arguments);
}
function n(e, r) {
  if (e) {
    if ("string" == typeof e) return o(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? o(e, r) : void 0;
  }
}
function o(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];
  return n;
}
var i = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
exports._createForOfIteratorHelper = function (e, r) {
  var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!t) {
    if (Array.isArray(e) || (t = n(e)) || r && e && "number" == typeof e.length) {
      t && (e = t);
      var o = 0,
        i = function () {};
      return {
        s: i,
        n: function () {
          return o >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[o++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: i
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a,
    l = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(e);
    },
    n: function () {
      var e = t.next();
      return l = e.done, e;
    },
    e: function (e) {
      u = !0, a = e;
    },
    f: function () {
      try {
        l || null == t.return || t.return();
      } finally {
        if (u) throw a;
      }
    }
  };
}, exports._defineProperty = r, exports._extends = t, exports._objectSpread2 = function (t) {
  for (var n = 1; n < arguments.length; n++) {
    var o = null != arguments[n] ? arguments[n] : {};
    n % 2 ? e(Object(o), !0).forEach(function (e) {
      r(t, e, o[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : e(Object(o)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
    });
  }
  return t;
}, exports._objectWithoutProperties = function (e, r) {
  if (null == e) return {};
  var t,
    n,
    o = function (e, r) {
      if (null == e) return {};
      var t,
        n,
        o = {},
        i = Object.keys(e);
      for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
      return o;
    }(e, r);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}, exports._slicedToArray = function (e, r) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, r) {
    var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == t) return;
    var n,
      o,
      i = [],
      a = !0,
      l = !1;
    try {
      for (t = t.call(e); !(a = (n = t.next()).done) && (i.push(n.value), !r || i.length !== r); a = !0);
    } catch (e) {
      l = !0, o = e;
    } finally {
      try {
        a || null == t.return || t.return();
      } finally {
        if (l) throw o;
      }
    }
    return i;
  }(e, r) || n(e, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}, exports._taggedTemplateLiteral = function (e, r) {
  return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}, exports.commonjsGlobal = i, exports.createCommonjsModule = function (e, r) {
  return e(r = {
    exports: {}
  }, r.exports), r.exports;
};